import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ContractsContextProvider } from '../contracts/ContractsContext';
import Tracfin from './Tracfin';

const TracfinRouter = () => {
  return (
    <ContractsContextProvider>
      <Routes>
        <Route index element={<Tracfin />} />
      </Routes>
    </ContractsContextProvider>
  );
};

export default TracfinRouter;
